"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateAssociations = updateAssociations;
exports.removeAssociation = removeAssociation;
exports.convertAssociationsMapToValues = convertAssociationsMapToValues;

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _ObjectAssociationTypes = _interopRequireDefault(require("customer-data-objects/constants/ObjectAssociationTypes"));

function associationIdsToValues(objectType, ids) {
  if (!ids) {
    return [];
  }

  return ids.map(function (id) {
    return objectType + " " + id;
  }).toArray();
}

function updateAssociations(objectType, subjectIds, associations) {
  var key = _ObjectAssociationTypes.default[objectType];
  return associations.update(key, function (ids) {
    return ids.concat(subjectIds);
  });
}

function removeAssociation(objectType, subjectId, associations) {
  var key = _ObjectAssociationTypes.default[objectType];
  var newAssociations = associations.get(key).filterNot(function (assocId) {
    return subjectId === assocId;
  });
  return associations.set(key, newAssociations);
}

function convertAssociationsMapToValues(associationsMap) {
  if (associationsMap.isEmpty()) {
    return {};
  }

  var contactIds = associationsMap.get('contactIds');
  var contactValues = associationIdsToValues(_ObjectTypes.CONTACT, contactIds);
  var companyIds = associationsMap.get('companyIds');
  var companyValues = associationIdsToValues(_ObjectTypes.COMPANY, companyIds);
  var dealIds = associationsMap.get('dealIds');
  var dealValues = associationIdsToValues(_ObjectTypes.DEAL, dealIds);
  var ticketIds = associationsMap.get('ticketIds');
  var ticketValues = associationIdsToValues(_ObjectTypes.TICKET, ticketIds);
  return {
    contactValues: contactValues,
    companyValues: companyValues,
    dealValues: dealValues,
    ticketValues: ticketValues
  };
}